import React, { useEffect, useRef } from "react";

// Renders raw HTML embed code (e.g. TicketsCandy widgets), executing any
// <script> tags in order so external libraries load before inline init calls.
export function EmbedHtml({ html, className, testid = "embed-html" }) {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    container.innerHTML = "";
    if (!html) return;

    const temp = document.createElement("div");
    temp.innerHTML = html;
    const scripts = Array.from(temp.querySelectorAll("script"));
    scripts.forEach((s) => s.parentNode && s.parentNode.removeChild(s));
    Array.from(temp.childNodes).forEach((n) => container.appendChild(n));

    let cancelled = false;
    (async () => {
      for (const old of scripts) {
        if (cancelled) return;
        await new Promise((resolve) => {
          const s = document.createElement("script");
          Array.from(old.attributes).forEach((a) => s.setAttribute(a.name, a.value));
          if (old.src) {
            s.async = false;
            s.onload = resolve;
            s.onerror = resolve;
          } else {
            s.textContent = old.textContent;
          }
          container.appendChild(s);
          if (!old.src) resolve();
        });
      }
    })();

    return () => { cancelled = true; };
  }, [html]);

  return <div ref={ref} className={className} data-testid={testid} />;
}
